<div class="progress-container" [class.ac-progress-center]="center" [ngStyle]="{'height': currentSize, 'width': currentSize}">
    <ng-lottie
        [options]="options"
    ></ng-lottie>
</div>
